var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-details"},[_c('Nav'),_c('div',{staticClass:"news-details-content"},[_c('h1',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.details.title))]),_c('p',{staticClass:"news-date"},[_vm._v(_vm._s(_vm.details.created_at))]),_c('div',{staticClass:"news-content",domProps:{"innerHTML":_vm._s(_vm.details.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }